import { render, staticRenderFns } from "./franjas.vue?vue&type=template&id=4fa6c40c&scoped=true"
import script from "./franjas.vue?vue&type=script&lang=js"
export * from "./franjas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa6c40c",
  null
  
)

export default component.exports